import { MaterialType } from "@app/strain/materials/models/material-type.enum";

export class Material {
    public id: number;
    public name: string;
    public quantity: number;
    public location: string;
    public type: MaterialType;
    public description: string;

    constructor(material: any = {}) {
        this.id = material.id;
        this.name = material.name || '';
        this.quantity = material.quantity || 0;
        this.location = material.location || '';
        this.type = material.type as MaterialType;
        this.description = material.description || '';
    }

}
